import React, { useContext, useEffect, useState } from 'react';
import { RenderIf } from '../../../helpers/RenderIf';
import { T, TraksConsumer } from '../../../traks';
import WhistlesContext from '../../../contexts/whistlesContext';
import MeContext from '../../../MeContext';
import { ContentHeader } from '../DashboardPage';
import DashboardContext from '../../../contexts/dashboardContext';
import { Avatar } from '../Users/Avatar';
import { Dropdown, Modal } from 'reactstrap';
import { NoWhistles } from './NoWhistles';
import { DaysToDeadline, PastTimeStamp } from '../../../c/TimeComponents';
import Logs from '../../../c/logs';
import { ChangeWhistleStatus, ShareWhistle, AssignWhistle } from '../../../c/whistleactions';
import { WhistleStatus } from 'c/Traks/WhistleStatus';


const getCompanyName = (company_id, whoami) => {
	return whoami.companies
		.find(company => company.id === company_id)["company_name"]
		|| ""
}

const WhistleButton = ({ whistle, handleOpenWhistle }) => {
	return (<>
		<div className="d-flex align-items-center">
			<RenderIf condition={whistle.whistle_access_id}>
				<div className="border_grey_1 px-3 py-2 border_radius_6px cursor_pointer d-flex primary fw_500" onClick={handleOpenWhistle}>
					<div><T>
						See entry
					</T>
					</div>
					<div className="ms-3">
						<img src="https://static.sibilus.eu/gfx/green-right-arrow-icon-0.svg" alt="arrow-icon" />
					</div>
				</div>
			</RenderIf>
			<RenderIf condition={!whistle["whistle_access_id"]}>
				<div className="ms-3">
					<WhistleModals whistle={whistle} />
				</div>
			</RenderIf>
		</div>
	</>)
}

const WhistleRow = ({ whistle }) => {
	const { whoami } = useContext(MeContext)
	const { setActiveTab, setOpenWhistle } = useContext(DashboardContext)
	const { updated_ts, status, deadline, company_id, categories } = whistle;

	const handleOpenWhistle = (whistle) => {
		setOpenWhistle(whistle.whistle_access_id)
		setActiveTab("Whistle")
	}

	const companyName = getCompanyName(company_id, whoami)
	const category = categories.length ? categories[0] : ""
	const assignee = whistle["access"] && whistle.access.find(el => el.type === "user")["screen_name"]
	const rowOnclick = whistle["whistle_access_id"] ? () => handleOpenWhistle(whistle) : null
	const pointerClass = whistle["whistle_access_id"] ? " cursor_pointer" : ""

	return (
		<tr className={`align-baseline ${pointerClass}`} onClick={rowOnclick}>
			<td className="py-4 ps-4 txt_blue_1">{companyName}</td>
			<td className="txt_blue_1"><Status status={status} /></td>
			<td className="txt_blue_1">{category}</td>
			<td>
				<div className="d-flex align-items-center">
					<div className="me-2">
						<Avatar screenName={assignee} />
					</div>
					<div className="txt_blue_1">
						{assignee}
					</div>
				</div>
			</td>
			<td>
				<DaysToDeadline deadlineInMs={deadline} />
			</td>
			<td className="txt_blue_1">
				<PastTimeStamp TimeStampInMs={updated_ts} />
			</td>
			<td>
				<div className="d-flex justify-content-end me-4">
					<WhistleButton
						whistle={whistle}
						handleOpenWhistle={() => handleOpenWhistle(whistle)}
					/>
				</div>
			</td>
		</tr>
	);
};

const Status = ({ status }) => {
	const statusText = WhistleStatus(status) 
	const color = status === "new"
		? "grey_avatar"
		: status === "processed"
			? "green_avatar"
			: status === "passedOn"
				? "orange_avatar"
				: "red_avatar"
	return <div className={`d-inline px-3 py-1 rounded-5 ${color}`}>{statusText}</div>;
};

const WhistlesTab = () => {
	const { whistlesTab, setWhistlesTab } = useContext(WhistlesContext)
	const baseClassList = "col-2 py-2 border-bottom text-center primary cursor_pointer"
	const userActive = whistlesTab === "user_whistles"
	const compayActive = whistlesTab === "company_whistles"
	return (

		<div className="d-flex flex-row justify-content-center" >
			<div className={`${baseClassList}`} >
				<div
					className={userActive ? "" : "light-grey-text"}
					onClick={() => setWhistlesTab('user_whistles')}
				>
					<span className={userActive ? "py-2 whistle-tab" : "py-2"}>
						<T>user entries</T>
					</span>
				</div>
			</div>
			<div className={baseClassList} >
				<div
					className={compayActive ? "" : "light-grey-text"}
					onClick={() => setWhistlesTab('company_whistles')}
				>
					<span className={compayActive ? "py-2 whistle-tab" : "py-2"}>
						<T>company entries</T>
					</span>
				</div>
			</div>
		</div>
	);
};
const WhistlesHeader = () => (
	<thead>
		<tr className="bg_light_grey">
			<th className="py-3 ps-4 txt_blue_1"><T>Company</T></th>
			<th className="py-3 txt_blue_1"><T>Status</T></th>
			<th className="py-3 txt_blue_1"><T>Category</T></th>
			<th className="py-3 txt_blue_1"><T>Assigned</T></th>
			<th className="py-3 txt_blue_1"><T>Deadline</T></th>
			<th className="py-3 txt_blue_1"><T>Latest activity</T></th>
			<th></th>
		</tr>
	</thead>
);

const WhistlesList = ({ children }) => {
	return (
		<div className="py-5">
			<table className="table sibilus_border sborder_radius_6px">
				<WhistlesHeader />
				<tbody className="bg-white">
					{children}
				</tbody>
			</table>
		</div>
	);
};


const WhistleModals = ({ whistle }) => {
	const [editStatusOpen, setEditStatusOpen] = useState(false)
	const [shareWhistleOpen, setShareWhistlesOpen] = useState(false)
	const [assignWhistleOpen, setAssignWhistlesOpen] = useState(false)
	const [showLogs, setShowLogs] = useState(false)

	const className= "btn fw_600 sibilus_border me-4 hoverable-grey"
	return (<>
		<Dropdown toggleText={"..."} align="right">
			<button className={className} onClick={() => setEditStatusOpen(true)}><T>Change Status</T></button>
			<button className={className} onClick={() => setShareWhistlesOpen(true)}><T>Share</T></button>
			<button className={className} onClick={() => setAssignWhistlesOpen(true)}><T>Assign whistle</T></button>
			<button className={className} onClick={() => setShowLogs(!showLogs)}><T>Logs</T></button>
		</Dropdown>
		<Modal isOpen={editStatusOpen} toggle={() => setEditStatusOpen(!editStatusOpen)} className={"modals"}>
			<div className="p-5">
				<ChangeWhistleStatus
					setEditStatusOpen={setEditStatusOpen}
					whistle={whistle}
				/>
			</div>
		</Modal>
		<Modal isOpen={shareWhistleOpen} toggle={() => setShareWhistlesOpen(!shareWhistleOpen)} className={"modals"}>
			<div className="p-5">
				<TraksConsumer>
					<ShareWhistle
						whistle={whistle}
					/>
				</TraksConsumer>
			</div>
		</Modal>
		<Modal isOpen={assignWhistleOpen} toggle={() => setAssignWhistlesOpen(!assignWhistleOpen)} className={"modals"}>
			<div className="p-5">
				<TraksConsumer>
					<AssignWhistle
						whistle={whistle}
					/>
				</TraksConsumer>
			</div>
		</Modal>
		<Modal isOpen={showLogs} toggle={() => setShowLogs(!showLogs)} className={"modals"}>
			<Logs
				whistle={whistle}
			/>
		</Modal>
	</>)
}

const WhistlesListFooter = ({ whistles }) => {
	return (
		<>
			<tr className="align-baseline">
				<td className="ps-4 py-4"
					// @ts-ignore
					colSpan={7}>
					<div className="d-flex near_white_grey fw_500">
						<T>
							Showing
						</T>
						{" " + whistles.length + " "}
						<T>out of</T>
						{" " + whistles.length + " "}
						<T>results</T>
					</div>
				</td>
			</tr>
		</>
	)
}

const Whistles = (props) => {
	const { me } = useContext(MeContext)
	const { whistles, whistlesTab, getWhistles } = useContext(WhistlesContext)
	const { updateData, setUpdateData } = useContext(DashboardContext)

	useEffect(() => {
		if(updateData){
			getWhistles(me)
			setUpdateData(false)
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [me, updateData])


	return (
		<div>
			<ContentHeader>
				<T>Entries</T>
			</ContentHeader>
			<RenderIf condition={whistlesTab}>
				<WhistlesTab />
			</RenderIf>
			<RenderIf condition={whistles !== undefined && whistles.length > 0}>
				<WhistlesList >
					{whistles.map((whistle, i) => (
						<WhistleRow whistle={whistle} key={'whistle' + i} />
					))}
					<WhistlesListFooter whistles={whistles} />
				</WhistlesList>
			</RenderIf>
			<RenderIf condition={whistles && whistles.length === 0}>
				<NoWhistles />
			</RenderIf>
		</div>
	);
};

export default Whistles;

